import * as React from 'react';
import { Avatar, Tag, Tooltip } from '../';

interface Props {
  users: Array<any>;
  handleClick?: Function;
  tooltip?: string;
}

const MiniUserList = ({ users, handleClick, tooltip = 'Remove' }: Props) => {
  if (!users || users.length === 0) {
    return null;
  }
  const isClickable = handleClick !== undefined;

  const ConditionalTooltip = ({ children, text }) => {
    if (text) {
      return <Tooltip text={text}>{children}</Tooltip>;
    }
    return children;
  };

  return (
    <ul className="mini-user-list">
      {users.map((user) => (
        <ConditionalTooltip
          key={user.id}
          text={isClickable ? tooltip : undefined}
        >
          <li
            className={isClickable ? 'is-clickable' : ''}
            onClick={() => {
              handleClick(user);
            }}
          >
            <span className="is-hidden-tablet-only">
              <Avatar size={32} email={user.email || ''} />
            </span>
            <Tag type="default">{user.name}</Tag>
          </li>
        </ConditionalTooltip>
      ))}
    </ul>
  );
};

export default MiniUserList;
